import React, { useEffect, useState } from 'react';
import { Table, Badge, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ROLES } from '../../../config/permissions.js';
import RoleIndicator from '../../atoms/RoleIndicator.js';
import '../../../css/UsersTable.css';

const UsersTable = ({ quoteToolClient }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setLoading(true);
                const usersList = await quoteToolClient.getUsers();
                setUsers(usersList);
            } catch (error) {
                toast.error('Error fetching users');
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, [quoteToolClient]);

    const renderStatusBadge = (user) => {
        if (user.isDisabled) {
            return <Badge color="danger">Disabled</Badge>;
        }
        return <Badge color="success">Active</Badge>;
    };

    const formatRoleHeader = (role) => {
        return role.split('-').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    if (loading) {
        return <Spinner />;
    }

    return (
        <Table bsSize="sm" responsive hover className="users-table">
            <thead>
                <tr>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Status</th>
                    {ROLES.map((role) => (
                        <th key={role} className="role-column">
                            {formatRoleHeader(role)}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {users.map((user) => (
                    <tr key={user.id}>
                        <td>
                            <Link to={`/admin/users/${user.id}`}>
                                {user.email}
                            </Link>
                        </td>
                        <td>{user.firstName} {user.lastName}</td>
                        <td>{renderStatusBadge(user)}</td>
                        {ROLES.map((role) => (
                            <td key={role} className="role-column">
                                <RoleIndicator hasRole={user.roles.includes(role)} />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default UsersTable;